const handleCartHeader = () => {
  const cartHeader = document.querySelector(".cart-header");
  const cartInner = document.querySelector(".cart-inner");
  if (!cartHeader || !cartInner) return;
  cartInner.prepend(cartHeader);
};

const handleCartTableRows = () => {
  const table = document.querySelector("table.cart-table");
  if (!table) return;

  table.querySelectorAll("tbody tr.removeable").forEach((row) => {
    const deleteForm = row.querySelector('form[action*="deleteCartItem"]');
    if (!deleteForm) return;

    // Drop any existing remove cells (incl. the empty one the browser
    // foster-parents) so each row ends up with exactly one .p-remove column.
    row.querySelectorAll("td.p-remove").forEach((cell) => cell.remove());

    const td = document.createElement("td");
    td.className = "p-remove";
    td.appendChild(deleteForm);
    row.appendChild(td);
  });

  // Remove foster-parented orphan buttons that the browser moved outside the table
  document.querySelectorAll(".remove-item").forEach((btn) => {
    if (!btn.closest("table.cart-table")) btn.remove();
  });
};

// Current storefront language as a 2-letter lowercase code (e.g. "cs", "en").
const getCartLang = () =>
  (
    (typeof dataLayer !== "undefined" && dataLayer[0]?.shoptet?.language) ||
    document.documentElement.lang ||
    "cs"
  )
    .slice(0, 2)
    .toLowerCase();

const addTableHeadToCartTable = () => {
  const cartTable = document.querySelector("table.cart-table");
  if (!cartTable) return;
  if (cartTable.querySelector("thead")) return; // don't duplicate the head

  const lang = getCartLang();

  const labels = {
    cs: { quantity: "Počet", unit: "Cena ks", total: "Celkem" },
    en: { quantity: "Quantity", unit: "Unit price", total: "Total" },
    de: { quantity: "Menge", unit: "Stückpreis", total: "Gesamt" },
    it: { quantity: "Quantità", unit: "Prezzo unit.", total: "Totale" },
    sk: { quantity: "Počet", unit: "Cena ks", total: "Spolu" },
  };
  const t = labels[lang] || labels.cs;

  const thead = document.createElement("thead");
  thead.innerHTML = `
        <tr>
            <th class="cart-p-image"></th>
            <th class="p-name"></th>
            <th class="p-availability"></th>
            <th class="p-quantity">${t.quantity}</th>
            <th class="p-price">${t.unit}</th>
            <th class="p-total">${t.total}</th>
            <th class="p-remove"></th>
        </tr>
    `;
  cartTable.prepend(thead);
};

// Builds the OSS "?" tooltip button (final price recalculated by the delivery
// country's tax rate).
const makeOssButton = (tip) => {
  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "show-tooltip question-tooltip oss-price-notification";
  btn.title = tip;
  btn.setAttribute("data-original-title", tip);
  btn.setAttribute("aria-label", "Více informací");
  btn.textContent = "?";
  return btn;
};

// On foreign-language versions Shoptet auto-adds the OSS price notice. The Czech
// version doesn't get it, so add it there only — both next to each row total and
// as a labelled note in the order summary.
const addOssPriceNotificationCs = () => {
  const lang = getCartLang();
  // Shoptet may report Czech as "cs" or "cz" depending on the setup.
  if (lang !== "cs" && lang !== "cz") return;

  const tip =
    "Finální cena se vypočítá podle sazby daně země doručení v košíku.";

  // Labelled "Doručení do zahraničí ?" note added to a price container.
  const addNote = (container, method) => {
    if (!container) return;
    if (container.querySelector(".oss-price-notification__wrapper")) return;
    const note = document.createElement("div");
    note.className = "oss-price-notification__wrapper";
    note.append("Doručení do zahraničí ");
    note.appendChild(makeOssButton(tip));
    container[method](note);
  };

  // Cart — a "?" tooltip with the full context next to each row total.
  document.querySelectorAll("table.cart-table td.p-total").forEach((cell) => {
    if (cell.querySelector(".oss-price-notification")) return;
    cell.appendChild(makeOssButton(`Doručení do zahraničí: ${tip}`));
  });

  // Cart order summary — note above the totals.
  document
    .querySelectorAll(".price-wrapper")
    .forEach((wrap) => addNote(wrap, "prepend"));

  // Product price block (detail / listing) — note below the price.
  document
    .querySelectorAll(".p-final-price-wrapper")
    .forEach((wrap) => addNote(wrap, "append"));
};

const handleCartDiscountCoupon = () => {
  const couponCode = document.querySelector(".extras-wrapper .discount-coupon");
  if (!couponCode) return;
  const sidebarInCart = document.querySelector(".sidebar-in-cart");
  if (!sidebarInCart) return;
  sidebarInCart.prepend(couponCode);
};

const handleStepBack = () => {
  const backBtn =
    document.querySelector(".sidebar-in-cart .next-step-back") ||
    document.querySelector("#checkoutSidebar .next-step-back");
  if (!backBtn) return;
  const cartInner = document.querySelector(".cart-inner");
  if (!cartInner) return;
  cartInner.appendChild(backBtn);
};

const handleExtraDiscount = () => {
  const extraDiscount = document.querySelector(".cart-summary .extra.discount");
  if (!extraDiscount) return;
  const sidebarInCart = document.querySelector(".sidebar-in-cart");
  if (!sidebarInCart) return;
  sidebarInCart.appendChild(extraDiscount);
};

const handleCartDelivery = () => {
  const cartDelivery = document.querySelector(".cart-summary .extra.delivery");
  if (!cartDelivery) return;
  const sidebarInCart = document.querySelector(".sidebar-in-cart");
  if (!sidebarInCart) return;
  sidebarInCart.prepend(cartDelivery);
};

const handleCartFooter = () => {
  const cartFooter = document.createElement("footer");
  cartFooter.classList.add("cart-footer");
  const contentWrapper = document.querySelector("#content-wrapper");
  if (!contentWrapper) return;
  contentWrapper.parentElement.insertBefore(
    cartFooter,
    contentWrapper.nextSibling
  );
  cartFooter.innerHTML = `
        <div class="container">
            <div>Bezpečná platba</div>
            <img src="/user/documents/upload/miranda/safe-payment.png" alt="Visa, Visa Electron, MasterCard, Apple Pay, Google Pay, PayPal" />
        </div>
    `;
};

const handleCartMessage = async () => {
  if (!document.body.classList.contains("in-krok-2")) return;

  fetch("/objednavka/krok-1/")
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const message = doc.querySelector(".site-msg-custom");
      if (!message) return;
      const cartInner = document.querySelector(".cart-content");
      if (!cartInner) return;
      cartInner.prepend(message);
    });
};

const handleEmptyCartMessage = () => {
  const cartEmpty =
    document.querySelector(".cart-empty") ||
    dataLayer[0].shoptet.cart?.length === 0;
  const cartInner = document.querySelector(".cart-inner");
  console.log(cartEmpty, cartInner);
  if (cartEmpty && cartInner) cartInner.classList.add("cart-empty");
  const emptyCartHeader =
    document.querySelector(".cart-empty h1") ||
    document.querySelector(".cart-empty .h1");
  if (!emptyCartHeader) return;
  const backShoppingLink = document.createElement("a");
  backShoppingLink.classList.add("btn", "btn-primary");
  backShoppingLink.href = "/";
  backShoppingLink.textContent = "Zpět do obchodu";
  emptyCartHeader.parentElement.insertBefore(
    backShoppingLink,
    emptyCartHeader.nextSibling
  );
  if (typeof prazdnyKosik !== "undefined") {
    const emptyCartMessage = document.createElement("div");
    emptyCartMessage.classList.add("empty-cart-message");
    emptyCartMessage.innerHTML = prazdnyKosik;
    emptyCartHeader.parentElement.insertBefore(
      emptyCartMessage,
      emptyCartHeader.nextSibling
    );
  }
};

export {
  handleCartHeader,
  handleCartTableRows,
  addTableHeadToCartTable,
  addOssPriceNotificationCs,
  handleCartDiscountCoupon,
  handleStepBack,
  handleExtraDiscount,
  handleCartDelivery,
  handleCartFooter,
  handleCartMessage,
  handleEmptyCartMessage,
};
